import PersonCheck from './PersonCheck';

export default PersonCheck;
